export const driverMediaType = {
  selfie: 'SELFIE',
  signature: 'SIGNATURE',
};
